import React from 'react'

export default function ToolsTechnology() {
  return (
    <>
    <section class="our_clientele_sec pt-0 mt-5">
        <div class="container">
          <div class="row">
            <div class="col-lg-12 text-center">
              <div
                class="heading row_gap"
                data-aos="fade-up"
                data-aos-duration="2000"
              >
                <h2>Tools & Technologies </h2>
              </div>
            </div>
          </div>
          <div class="row row-cols-lg-6 g-2 row-cols-md-5 row-cols-sm-4 row-cols-3 justify-content-center align-items-center ">
            <div class="col-lg">
              <div
                class="client_box"
                data-aos="zoom-in"
                data-aos-duration="2000"
              >
                <img src="assets/image/tools-1.jpg" class="img-fluid" alt="" />
              </div>
            </div>
            <div class="col-lg">
              <div
                class="client_box"
                data-aos="zoom-in"
                data-aos-duration="2000"
              >
                <img src="assets/image/tools-2.jpg" class="img-fluid" alt="" />
              </div>
            </div>
            <div class="col-lg">
              <div
                class="client_box"
                data-aos="zoom-in"
                data-aos-duration="2000"
              >
                <img src="assets/image/tools-3.jpg" class="img-fluid" alt="" />
              </div>
            </div>

            <div class="col-lg">
              <div
                class="client_box"
                data-aos="zoom-in"
                data-aos-duration="2000"
              >
                <img src="assets/image/tools-4.jpg" class="img-fluid" alt="" />
              </div>
            </div>
            <div class="col-lg">
              <div
                class="client_box"
                data-aos="zoom-in"
                data-aos-duration="2000"
              >
                <img src="assets/image/tools-5.jpg" class="img-fluid" alt="" />
              </div>
            </div>
            <div class="col-lg">
              <div
                class="client_box"
                data-aos="zoom-in"
                data-aos-duration="2000"
              >
                <img src="assets/image/tools-6.jpg" class="img-fluid" alt="" />
              </div>
            </div>

            <div class="col-lg">
              <div
                class="client_box"
                data-aos="zoom-in"
                data-aos-duration="2000"
              >
                <img src="assets/image/tools-7.jpg" class="img-fluid" alt="" />
              </div>
            </div>
            <div class="col-lg">
              <div
                class="client_box"
                data-aos="zoom-in"
                data-aos-duration="2000"
              >
                <img src="assets/image/tools-8.jpg" class="img-fluid" alt="" />
              </div>
            </div>
            <div class="col-lg">
              <div
                class="client_box"
                data-aos="zoom-in"
                data-aos-duration="2000"
              >
                <img src="assets/image/tools-9.jpg" class="img-fluid" alt="" />
              </div>
            </div>
            <div class="col-lg">
              <div
                class="client_box"
                data-aos="zoom-in"
                data-aos-duration="2000"
              >
                <img src="assets/image/tools-10.jpg" class="img-fluid" alt="" />
              </div>
            </div>
            <div class="col-lg">
              <div
                class="client_box"
                data-aos="zoom-in"
                data-aos-duration="2000"
              >
                <img src="assets/image/tools-11.jpg" class="img-fluid" alt="" />
              </div>
            </div>
            <div class="col-lg">
              <div
                class="client_box"
                data-aos="zoom-in"
                data-aos-duration="2000"
              >
                <img src="assets/image/tools-12.jpg" class="img-fluid" alt="" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
